import React, { useContext } from 'react';
import { trimmer } from '../helpers';
import { JobContext } from '../JobContext';
export var JobTitle = function JobTitle() {
  var _useContext = useContext(JobContext),
      prefix = _useContext.prefix,
      title = _useContext.title,
      forceSmall = _useContext.forceSmall;

  return /*#__PURE__*/React.createElement("h3", {
    className: "".concat(prefix, "__content-title")
  }, trimmer(title, 30, forceSmall));
};
JobTitle.displayName = "JobTitle";